import http from '../../core/services/http';

export const loadAddresses = searchTerm =>
  http.get('exception/address/search', { params: { formatted: searchTerm } }).then(response => response.data);

export const loadBestMatchAddress = address =>
  http.get('exception/address/bestmatch', { params: { formatted: address } }).then(response => response.data);
